<template>
  <ul>
    <li v-for="item in $mainMenu" :key="item.slug">
      <router-link :to="{ path: (lang ? '/' + lang + '/' : '/') + item.uri }">
        {{ $t(`mainMenu.${item.slug}`) }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HeaderTop2',
  data() {
    return {
      // initialized: false,
      isOpen: false,
      lang: '',
    }
  },
  computed: {
    ...mapState(['exchangeRate']),
    filterdLocales: function() {
      return this.locales.filter(item => item != this.$locale)
    },
  },
  methods: {
    changeLocale(locale) {
      let newPathname = ''

      if (locale === 'ru' && this.$locale === 'ua') {
        newPathname = `/ru${window.location.pathname}`
        // newPathname = `/ru${this.$route.path}`

        this.$store.dispatch('changeLang', 'ru')
        this.$locale = locale
        this.$router.push(newPathname)
        this.$lang = locale
      } else if (locale === 'ua' && this.$locale === 'ru') {
        // console.log('to ua')
        // newPathname = this.$route.path.substring(3)
        newPathname = window.location.pathname.substring(3)

        this.$store.dispatch('changeLang', '')
        this.$locale = locale
        this.$router.push(newPathname)
        this.$lang = locale
      }
    },
    onToggle() {
      this.isOpen = !this.isOpen
    },
    fixheaderTop() {},
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.fixheaderTop)
      this.fixheaderTop()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fixheaderTop)
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>
